import { GenericDateFilterFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const ClockinDateFilterStore = GenericDateFilterFactory(GENERIC_IDS.CLOCKINS);